import { useState, useCallback } from "react";
import * as Constants from "../components/Constants.js";

const usePutURL = () => {
  const [isGrabando, setGrabando] = useState(false);
  const [erroresPut, setErroresPut] = useState(null);

  const putData = useCallback(async (path, datos, datosGrabados) => {
    setGrabando(true);
    setErroresPut(null);

    try {
      const response = await fetch(Constants.URLBASE + "/" + path, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datos),
        redirect: "follow",
        credentials: "include",
      });

      if (response.status === 401) {
        document.location.href = "/nosession";
      } else if (response.redirected) {
        document.location = response.url;
      } else if (!response.ok) {
        const json = await response.json();
        setErroresPut(json.errors ?? json.errores ?? ["Error al insertar los datos"]);
      } else {
        const env = await response.json().catch(() => null);
        if (env && (env.ok === true || env.ok === false || 'data' in env || 'errors' in env || 'errores' in env)) {
          if (env.ok) {
            datosGrabados(response.headers.get('Location') ?? env.data ?? null);
          } else {
            setErroresPut(env.errors ?? env.errores ?? ["Error al insertar los datos"]);
          }
        } else {
          datosGrabados(response.headers.get('Location'));
        }
      }
    } catch (err) {
      console.error("Error Put", err.message);
      setErroresPut(["Error al insertar los datos"]);
    }
    setGrabando(false);
  }, []);

  const resetErroresPut = useCallback(() => {
    setErroresPut(null);
  }, []);

  return {isGrabando, erroresPut, putData, resetErroresPut};
};

export default usePutURL;
